import Image from 'next/image';
import { FormattedMessage } from 'react-intl';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import logUpsellProductClicked from '@alltrails/amplitude/events/logUpsellProductClicked';
import useUser from '@alltrails/context/hooks/useUser';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import PeakContainerBadge from '@alltrails/denali/components/SubscriptionBadge/Container/Peak';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import { useUpsellNavigation } from '../BaseUpsell/UpsellNavigationContext';
import headerImage from '../GenericPeakUpsell/images/peak-header.avif';
import styles from './PeakInfoModule.module.scss';

type Props = {
  upsellTrigger: UpsellTrigger;
};

// Plus-only "Try Peak" cross-sell module. Design: https://www.figma.com/design/5lZfiEveGScwx75JKpB12W/Upsell-XPs-2026?node-id=5842-59536&m=dev
export default function PeakInfoModule({ upsellTrigger }: Props) {
  const upsellNavigation = useUpsellNavigation();
  const user = useUser();
  const isPromoEligible = user?.isPromoEligible || false;

  if (!upsellNavigation) {
    return null;
  }

  const handleClick = () => {
    logUpsellProductClicked({
      product_type: 'peak',
      purchase_screen_type_plan: isPromoEligible ? 'free trial' : 'non trial',
      trigger: upsellTrigger
    });

    upsellNavigation.navigateToPeakUpsell();
  };

  return (
    <div className={styles.container}>
      <div className={styles.asset}>
        <Image alt="" className={styles.image} sizes={`(max-width: ${BREAKPOINT_SM_SIZE}px) 100vw, 408px`} src={headerImage} />
      </div>
      <div className={styles.content}>
        <div className={styles.copy}>
          <PeakContainerBadge size="sm" />
          <Heading as="h3" className={styles.heading} size="300">
            <FormattedMessage defaultMessage="Backpacking? Try Peak instead." />
          </Heading>
        </div>
        <Button
          onClick={handleClick}
          size="sm"
          text={isPromoEligible ? <FormattedMessage defaultMessage="Try Peak free" /> : <FormattedMessage defaultMessage="Continue with Peak" />}
          variant="primary"
        />
      </div>
    </div>
  );
}
